import axiosInstance from '../axiosInstance';

export const fetchTaxiServiceType = async () => {
    const response = await axiosInstance.get('/administration/taxi-service-type');
    return response.data;
};

export const createTaxiServiceType = async (data) => {
    const response = await axiosInstance.post('/administration/taxi-service-type', data);
    return response.data;
};

export const updateTaxiServiceType = async (id, data) => {
    const response = await axiosInstance.put(`/administration/taxi-service-type/${id}`, data);
    return response.data;
};

export const deleteTaxiServiceType = async (id) => {
    const response = await axiosInstance.delete(`/administration/taxi-service-type/${id}`);
    return response.data;
};